module.exports = __webpack_public_path__ + "static/1704b132e7dd3f524509f9c4379d993536ca886d2fc12baffcb3fa833a0e57c1-810fbaf2aeda5bcf183a4819bbbe54b1.jpeg";